module.exports = __webpack_public_path__ + "static/media/60_tn.ed18cd33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/60_tn.jpg
// module id = 368
// module chunks = 0